import React, { useState } from "react";
import { Row, Form, Col, Button } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';

export default function PointSetting(props) {
    const questionIndex = props.index;
    const data = props.data || { has_bonus: 0, bonus: null };
    const dispatch = useDispatch();

    function onSelect(e) {
        try {
            let tmp = parseInt(e.currentTarget.value);
            if (false == isNaN(tmp)) {
                console.log(tmp);
                dispatch({
                    type: "QUESTION_SET_BONUS",
                    index: questionIndex,
                    data: { has_bonus: tmp, bonus: data.bonus }
                });
            }
        } catch (e) {

        }
    }

    function onCustomOptChanged(e) {
        // console.log(e.currentTarget.value);
        try {
            let tmp = parseInt(e.currentTarget.value);
            if (false == isNaN(tmp) && tmp >= 1) {
                dispatch({
                    type: "QUESTION_SET_BONUS",
                    index: questionIndex,
                    data: { has_bonus: data.has_bonus, bonus: tmp }
                });
            }
        } catch (e) {
            console.warn(e.stack);
        }
    }

    function render() {
        // console.log(subOpt);
        let customOpt = <input type="number" value={data.bonus && isNaN(data.bonus) ? 0 : data.bonus} onChange={onCustomOptChanged} />;

        return (
            <>
                <label>
                    針對回答到重要題目的受訪者，可能是您的重要客戶，或是完成了某些關鍵題目
                </label><label>
                    您可以設定額外的獎勵，來感謝他們的參與。
                </label><br /><br />
                <label>(額外贈點，點數將於結帳時與調查金額合併計算)</label>
                <Form className="mt-1">
                    <Col className="text-left">
                        <Form.Check onChange={onSelect} type="radio" checked={data.has_bonus == 0 || data.has_bonus == "0"} name={questionIndex + "-no-rand"} value="0" label="不贈點" />
                    </Col>
                    <Col className="text-left">
                        <Form.Check onChange={onSelect} type="radio" checked={data.has_bonus == 1 || data.has_bonus == "1"} name={questionIndex + "-no-rand"} value="1" label="贈點" />
                    </Col>
                    {(data.has_bonus && data.has_bonus == 1) ? customOpt : null}
                </Form>
            </>
        );
    }

    return render();
}
